import { render, staticRenderFns } from "./PortDetails.vue?vue&type=template&id=7a83eda8&scoped=true&"
import script from "./PortDetails.vue?vue&type=script&lang=js&"
export * from "./PortDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortDetails.vue?vue&type=style&index=0&id=7a83eda8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83eda8",
  null
  
)

export default component.exports